import React, { Component } from 'react';
import { connect } from 'react-redux'
import { addToCart } from './actions/cartActions'
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import swal from 'sweetalert';
import { fetchData, selectMainCategory } from './reducers/cartReducer'
import Navbar from './Navbar'
import startOrder from '../images/TheBakeryBanner.png'
import scones from '../images/SCONES.jpg'

const taxrate = 0.0915;



class Start extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: "",
            daysOpen: [],
            showImage: true,
            message: "",
        }
    }
    componentDidMount() {

        fetch(this.props.commonUrl+'getInventory.php?revenueCenter=Bakery')
            .then((response) => {
                return response.json();
            }).then(data => {
                this.setState({ status: data.active })
                this.setState({ daysOpen: data.daysOpen })
                this.setState({ message: data.Comment })

            });
        if (this.props.items.length == 0) {
            this.props.fetchData();
        }

    }

    handleClick = (mainCategory) => {

        if (mainCategory) {
            this.props.selectMainCategory(mainCategory);
            this.props.history.push("/home")

        }

    }
    handleAgree(value) {

        this.setState({ showImage: false });

    }


    render() {
        var flag = ''
        if (this.props.location.state) {
            flag = this.props.location.state.flag
        } else {
            flag = false;
        }
        //var tempDate = new Date();
       // var day = tempDate.getDay();
       // var centerOpen = false
        //if (this.state.daysOpen.includes(day) && this.state.status == 1) {
        if (this.state.status == 1) {
          var  centerOpen = true
        }

        let mainCategory = []
        if (this.props.items.length > 0) {
            this.props.items.forEach(element => {
                if (element.mainCategory != null && mainCategory.indexOf(element.mainCategory) == -1)
                    mainCategory.push(element.mainCategory)
            });
        }

        let Item1 = "../src/images/"

        return (
            <div>
                <Navbar isAuthed={true} />
                {centerOpen == true ?
                    <div className="container">
                        <br />
                        {this.state.showImage && !flag ? <a onClick={() => { this.handleAgree("showImage") }} >
                            <img class="responsive-img" src={startOrder} />
                        </a> : ""}

                        {!this.state.showImage || flag ? <div><br />
                            <h5 className="center menuselect">Select the menu</h5>
                            <div className="mainmenu box">
                                {this.props.items.length > 0 ?
                                    mainCategory.map((item) =>
                                        <div className="main card" key={item} onClick={() => { this.handleClick(item) }}>

                                            <div className="card-image">

                                                  <img src={Item1 + item + ".jpg"} onError={(e) => { e.target.onerror = null; e.target.src = "" }} />
                                              {/*  <img src={scones} onError={(e) => { e.target.onerror = null; e.target.src = "" }} />*/}


                                                <span class="mainName" ><b>{" " + item}</b></span>
                                            </div>


                                        </div>
                                    ) : ""
                                }
                            </div>

                        </div> : ""}

                    </div> : <div className="container"><br /><div class="materialert danger ">
                        <div class="material-icons">error_outline</div>
                        {this.state.message}
                    </div></div>}
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {

        items: state.items,
        orders: state.orders
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => { dispatch(fetchData()) },
        selectMainCategory: (id) => { dispatch(selectMainCategory(id)) },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Start)